import { BASE_URL } from './config'

export async function getConversations(token: string) {
  const res = await fetch(`${BASE_URL}/api/v1/aurora/conversations`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!res.ok) throw new Error('Failed to fetch conversations')
  return res.json()
}

export async function getConversation(token: string, id: string) {
  const res = await fetch(`${BASE_URL}/api/v1/aurora/conversations/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!res.ok) throw new Error('Failed to fetch conversation')
  return res.json()
}

export async function sendMessage(
  token: string,
  message: string,
  conversationId?: string,
) {
  const res = await fetch(`${BASE_URL}/api/v1/aurora/chat`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ message, conversationId }),
  })
  if (!res.ok) throw new Error('Failed to send message')
  return res.json()
}

export async function deleteConversation(token: string, id: string) {
  const res = await fetch(`${BASE_URL}/api/v1/aurora/conversations/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!res.ok) throw new Error('Failed to delete conversation')
  return res.json()
}
